import {XauditModel} from '../xaudit.model';

export class FeeCodeToothConfiguration extends XauditModel {
  Code: string;
  ToothId: string;
  isSelected: boolean;
}
